import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../Controls/TextBoxControl"
import GridControl from "../../../Controls/GridControl"
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ShowEngineerResidentialInfo from "../../../Controls/ShowEngineerResidentialInfo"
import { useNavigate } from "react-router-dom";

import {
	GetLocal,
	SetLocal,
	FetchService,
	Base64Type
} from "../../../Base/BaseControl";
import ButtonControl from '../../../Controls/ButtonControl';

let ResultRow = '';
export default function Index(props) {
	const navigate = useNavigate();
	const [getServiceResult, setServiceResult] = useState(false);
	const [getPdf, setPdf] = useState('');
	const [showModal, setShowModal] = useState(false);
	const [getDeleteModal, setDeleteModal] = useState(false);

	useEffect(() => {
		ShowEngineerReportsList();
	}, []);

	const ShowEngineerReportsList = () => {
		var inputValue = {
			session: GetLocal('EngineerSession'),
			fileNumber: GetLocal('FileNumber')
		};
		FetchService("Engineer/Request/ShowEngineerReportsList", inputValue, ShowEngineerReportsListSuccess);
	}

	const ShowEngineerReportsListSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult.EngineerReportsListInfo);
	}

	let customRenderCell = {
		Edit: (row) => (
			<i class="fa fa-edit" onClick={() => EngineerReportFetch(row)}></i>
		),
		Delete: (row) => (
			<i class="fa fa-remove text-danger" onClick={() => ConfirmAction(row)}></i>
		),
		Print: (row) => (
			<i class="fa fa-print" onClick={() => ShowLastConstruction(row)}></i>
		),
		ShowFile: (row) => (
			<i class="fa fa-download" onClick={() => GetEngineerReportFile(row)}></i>
		),
		OffenceStatus: (row) => (
			row.OffenceStatus ? 'دارد' : 'ندارد'
		)
	};

	const EngineerReportFetch = (value) => {
		navigate("/Engineer/CreateEngineerReport?edit=1&page=ثبت گزارش", { state: value });
	}

	const ShowLastConstruction = (row) => {
		var inputValue = {
			session: GetLocal('EngineerSession'),
			id: row.ID
		};
		FetchService("Engineer/Request/ShowEngineerReport", inputValue, ShowEngineerReportSuccess);
	}

	const ShowEngineerReportSuccess = (ServiceResult) => {
		const prefix = Base64Type(ServiceResult.ExtensionFile);

		const fileData = prefix + ServiceResult.Base64Content;

		setPdf(fileData);
		setShowModal(true);
	};

	const GetEngineerReportFile = (row) => {
		var inputValue = {
			session: GetLocal('EngineerSession'),
			id: row.ID
		};
		FetchService("Engineer/Request/GetEngineerReportFile", inputValue, GetEngineerReportFileSuccess);
	}

	const GetEngineerReportFileSuccess = (ServiceResult) => {
		var a = document.createElement("a");
		a.href = Base64Type(ServiceResult.ExtensionFile) + ServiceResult.Base64Content;
		a.download = Math.floor(Math.random() * 10000) + "." + ServiceResult.ExtensionFile;
		a.click();
		a.remove();
	}

	const ConfirmAction = (row) => {
		ResultRow = row;
		ShowModalConfirm(row);
	}

	const ShowModalConfirm = (row) => {
		setDeleteModal('confirm');
		return (
			<Modal dialogClassName="modalConfirm" show={getDeleteModal} onHide={() => setDeleteModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title></Modal.Title>
				</Modal.Header>
				<Modal.Body>
					آیا از ادامه عملیات اطمینان دارید؟
				</Modal.Body>
				<Modal.Footer>
					<Button variant="success" onClick={() => DeleteEngineerReport(row)}>
						بله
					</Button>
					<Button variant="danger" onClick={() => setDeleteModal(false)}>
						خیر
					</Button>
				</Modal.Footer>
			</Modal>
		)
	}

	const DeleteEngineerReport = (row) => {
		var inputValue = {
			session: GetLocal('EngineerSession'),
			id: ResultRow.ID
		};
		FetchService("Engineer/Request/DeleteEngineerReport", inputValue, DeleteEngineerReportSuccess);
	}

	const DeleteEngineerReportSuccess = () => {
		setDeleteModal(false);
		//toast.success('اطلاعات شما با موفقیت ذخیره گردید');
		ShowEngineerReportsList();
	}

	return (
		<div>
			<ShowEngineerResidentialInfo />

			<GridControl
				data={getServiceResult}
				customHeaders={{ "BuildingStageTitle": "مرحله", "CreatedOn": "تاریخ", "OffenceStatus": "وضعیت خلاف", "Description": "توضیحات", "ReviewStatus": "وضعیت بررسی", "Edit": "ویرایش گزارش", "Delete": "حذف گزارش", "Print": "چاپ گزارش", "ShowFile": "دانلود فایل" }}
				customRenderCell={customRenderCell}
			/>

			<Modal dialogClassName="modalUi" show={showModal} onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title></Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{getPdf.startsWith("data:application/pdf") ? (
						<iframe
							src={getPdf}
							width="100%"
							style={{ height: "500px" }}
						/>
					) : getPdf.startsWith("data:image") ? (
						<div className='d-flex flex-column align-items-center'>
							<img
								src={getPdf}
								alt="Report"
								style={{ maxWidth: "100%", maxHeight: "500px" }}
							/>
							<ButtonControl
								onClick={() => window.open(getPdf)}
								title={"دانلود فایل"}
								variant={"primary"}
								className="mx-auto my-3"
							/>
						</div>
					) : (
						<div className="text-center">
							<ButtonControl
								onClick={() => window.open(getPdf)}
								title={"دانلود فایل"}
								variant={"primary"}
								className="mx-auto my-3"
							/>

						</div>
					)}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="danger" onClick={() => setShowModal(false)}>
						بستن
					</Button>
				</Modal.Footer>
			</Modal>
			{getDeleteModal == 'confirm' && <ShowModalConfirm />}
		</div>
	);
}
